/**
 * Qué versión es esta.
 *
 * Hace falta por una razón práctica: la app se instala en las tablets y el
 * service worker puede tener una versión vieja guardada durante días. Sin un
 * número a la vista, «no me funciona» y «a mí sí» son la misma frase y no hay
 * manera de saber si las dos tablets tienen lo mismo.
 *
 * Los dos valores los pone el build (ver `vite.config.ts`). La imagen de
 * producción se construye en Docker y ahí **no hay `.git`**, así que la versión
 * entra como argumento de build y el Makefile la saca de git al desplegar. Si no
 * llega nada, dice `dev`: es mejor que decir un número que no es verdad.
 */
declare const __APP_VERSION__: string
declare const __BUILT_AT__: string

export const VERSION: string = __APP_VERSION__
/** Instante ISO en que se compiló. */
export const BUILT_AT: string = __BUILT_AT__

/** «0.1.0+2f97e5c · 26 sept 2026», para leerlo en la pantalla de sistema. */
export function versionLegible(builtAt = BUILT_AT): string {
  const fecha = new Date(builtAt)
  if (Number.isNaN(fecha.getTime())) return VERSION
  const dia = new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(fecha)
  return `${VERSION} · ${dia}`
}
